import React from 'react';
import { useField, ErrorMessage } from 'formik';
import { Text } from '@rsos/components/capstone/base';
import { StyledTextArea } from './AviveSearchForm.styles';

const TextArea = ({ name, errors, touched, ...rest }) => {
  const [field] = useField(name);
  return (
    <>
      <StyledTextArea
        {...field}
        {...rest}
        error={errors[name] && touched[name]}
      />
      <Text size="small">
        <ErrorMessage name={name} />
      </Text>
    </>
  );
};

export default TextArea;
